import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import PaidOrdersLayer from "../../components/orders/PaidOrdersLayer";

const PaidOrdersPage = () => {
    return (
        <MasterLayout>
            <PaidOrdersLayer />
        </MasterLayout>
    );
};

export default PaidOrdersPage;
